import { render, staticRenderFns } from "./noDataImg.vue?vue&type=template&id=0aa12018&scoped=true"
import script from "./noDataImg.vue?vue&type=script&lang=js"
export * from "./noDataImg.vue?vue&type=script&lang=js"
import style0 from "./noDataImg.vue?vue&type=style&index=0&id=0aa12018&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa12018",
  null
  
)

export default component.exports